<template>
  <div>
    <app-notification :from-boti="false"
                  :title="`התזרים של ${monthName} מוכן `"
                  :text="'אפשר לעבור על התזרים ולערוך אותו עם העפרון ✏️'"
                  :notification-buttons="[
                    {
                      size:'normal',
                      title:'להסבר על התזרים',
                      subTitle: 'איך בנינו אותו?',
                      variant: 'primary',
                      action: openTour,
                    },
                    {
                      size:'normal',
                      title:'לתזרים',
                      variant: 'secondary',
                      action: skipTour,
                    },
                  ]"></app-notification>
  </div>
</template>

<script>
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';

export default {
  name: 'CashflowTourNotification',
  components: {
    AppNotification,
  },
  props: {
    monthName: {
      type: String,
      required: true,
    },
    onOpenTour: {
      type: Function,
      required: true,
    },
    onCloseTour: {
      type: Function,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('CashflowTourNotificationShown');
  },
  methods: {
    openTour() {
      Segment.trackUserInteraction('CashflowTourOpenClicked');
      this.onOpenTour();
    },
    skipTour() {
      Segment.trackUserInteraction('CashflowTourSkipClicked');
      this.onCloseTour();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
